import { useJsApiLoader } from '@react-google-maps/api'
import { createContext, useContext, ReactNode } from 'react'

const libraries: 'places'[] = ['places']

interface IGoogleMapsContext {
  isLoaded: boolean
}

const GoogleMapsContext = createContext<IGoogleMapsContext>({ isLoaded: false })

export function useGoogleMaps() {
  return useContext(GoogleMapsContext)
}

interface IProps {
  children: ReactNode
}

export function GoogleMapsProvider({ children }: IProps) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '',
    libraries,
    language: 'pt-BR',
    region: 'BR'
  })

  return <GoogleMapsContext.Provider value={{ isLoaded }}>{children}</GoogleMapsContext.Provider>
}
